import { render, staticRenderFns } from "./DueDiligenceTrap.vue?vue&type=template&id=a8519e04"
import script from "./DueDiligenceTrap.vue?vue&type=script&lang=js"
export * from "./DueDiligenceTrap.vue?vue&type=script&lang=js"
import style0 from "./DueDiligenceTrap.vue?vue&type=style&index=0&id=a8519e04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports